import { render } from "./MenuBanner.vue?vue&type=template&id=f6ecddaa&scoped=true"
import script from "./MenuBanner.vue?vue&type=script&lang=js"
export * from "./MenuBanner.vue?vue&type=script&lang=js"

import "./MenuBanner.vue?vue&type=style&index=0&id=f6ecddaa&scoped=true&lang=scss"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ecddaa"]])

export default __exports__